export default __webpack_public_path__ + "static/media/icons8-office-365.62497284.svg";